import React from 'react';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

interface IProps {
  errors: string[]
  isShowingWarningMax10: boolean;
  isReservationSuccessful: boolean;
}

const ReservationErrors: React.SFC<IProps> = ({ 
  errors = [],
  isShowingWarningMax10,
  isReservationSuccessful,
}) => {

  if (isReservationSuccessful && !errors.length && !isShowingWarningMax10) {
    return null;
  }

  return (
    <div className='reservation-errors'>
      <FormattedText 
        style='title'
        displayName='Observera'
        formattedName='order.seatpicker.obs'
      />
      { !isReservationSuccessful &&
        <div>
          <FormattedText 
            displayName='Reservationen misslyckades. Platsen är inte längre tillgänglig.'
            formattedName='order.seatpicker.notsuccessful'
          />
        </div>
      }
      { isShowingWarningMax10 &&
        <div>
          <FormattedText 
            displayName='För att reservera mer än 10 platser, vänligen kontakta Julius Biljettservice Callcenter.'
            formattedName='order.seatpicker.warning.max'
          />
        </div>
      }
      { errors.map((e: string, i: number) => 
        <div key={ `error${ i }` }>{ e }</div>)
      }
    </div>
  );
};

export default ReservationErrors;


// WEBPACK FOOTER //
// ./src/components/PickSeatManually/ReservationErrors/ReservationErrors.tsx